import Vue from 'vue';
import Component from 'vue-class-component';
import {getTreeChildren} from '../../models/NavTreeModel';


@Component({
    name:"tree-item",

    props:{
        viewportid:{
        },
        rootlink:{
        },
        currentlink:{
        },
        parentlink:{
        },
        contextpath:{
        }  
    }
})
export default class TreeItem extends Vue{
viewportid:string;
rootlink:string;
currentlink:string;
parentlink:string;
contextpath:string;

hasChilds:boolean=false;
isOpen:boolean=false;

public itemChildren=[];


created(){

    /*
    console.log('INSIDE TREE_ITEM.ts');
    
    console.log('viewport:',this.viewportid);
    console.log('rootlink:',this.rootlink);
    console.log('currentLink:',this.currentlink);
    console.log('parentLink:',this.parentlink);
    console.log('contextPath:',this.contextpath);
*/

    getTreeChildren(
        this.contextpath,
        this.viewportid,
        this.rootlink,
        this.parentlink,
        this.currentlink
    )
    .then((children)=>{
        if(children && children.length>0){
            this.hasChilds=true;
            this.itemChildren=children;
           // console.dir(children);
        }
    })
    .fail((jqXHR,textStatus, errorThrown)=>{

    })
}

filterChildTitle(title:string):string{
    return title.replace(/ *\([^)]*\) *$/, ""); 
  //return title; 
} 

hasChildren(childId:string):boolean{
    return true;
}
 
isActive(link:string):boolean{
return this.currentlink===link;
}

isNode(element):boolean{
    return false;
}

isLeaf(element):boolean{
return false;
}

}
